import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BrowserUtils } from '@azure/msal-browser';
import { ProfileComponent } from './profile/profile/profile.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found/page-not-found.component';
import { FailedComponent } from './login/failed/failed.component';
import { MarketBlotterComponent } from './market-blotter/view-market-blotter/marketblotter.component';
import { SummaryReportComponent } from './summary-report/view-summary-report/summary-report.component';

const routes: Routes = [
  {
    path: 'profile',
    component: ProfileComponent
  },
  {
    path: '',
    component: MarketBlotterComponent
  },
  {
    path: 'login-failed',
    component: FailedComponent
  },
  {
    path: 'market-blotter',
    component: MarketBlotterComponent
  },
  {
    path: 'summary-report',
    component: SummaryReportComponent
  },
  {
    path: 'physical-market',
    loadComponent: () => import('./potential-trade-blotter/potential-trade-blotter.component').then(m => m.PotentialTradeBlotterComponent)
  },
  {
    path: 'physical-market/fullscreen',
    loadComponent: () => import('./potential-trade-blotter/components/fullscreen/potential-trade-blotter-fullscreen.component').then(m => m.PotentialTradeBlotterFullscreenComponent)
  },
  // ADD ALL NEW PAGES ABOVE THIS 404 PAGE
  {
    path: '**',
    pathMatch: 'full',
    component: PageNotFoundComponent,
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    // Don't perform initial navigation in iframes or popups
    initialNavigation: !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'disabled' // Set to enabledBlocking to use Angular Universal
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
